import React from 'react';
import { Box, Inscription, OutlinedCompleteIcon, RoundBlockIcon } from '@common-fe/common-fe';

import { PropertyChangeItem } from './SyncUpdatesModal.types';

interface Props {
  item: PropertyChangeItem;
  isSelected: boolean;
  isAppliedToLowerOrgs: boolean;
  isBold: boolean;
}

const ConfirmUpdatesPropertyRow: React.FC<Props> = ({ item, isSelected, isAppliedToLowerOrgs, isBold }) => (
  <Box direction="row" align="center" data-testid={`confirm-updates-modal_property-row_${item.propertyName}`}>
    <Box flex pad={{ left: isBold ? undefined : 'spacing16' }}>
      <Inscription color="textTitle" weight={isBold ? 'bold' : 'normal'} data-testid={`confirm-updates-modal_property-name_${item.propertyName}`}>
        {item.displayName}
      </Inscription>
    </Box>
    <Box width="80px" align="center">
      <OutlinedCompleteIcon
        data-testid={`confirm-updates-modal_this-org-check_${item.propertyName}`}
        size="16px"
        color="success"
      />
    </Box>
    <Box width="120px" align="center">
      {isAppliedToLowerOrgs ? (
        <OutlinedCompleteIcon
          data-testid={`confirm-updates-modal_lower-orgs-check_${item.propertyName}`}
          size="16px"
          color="success"
        />
      ) : (
        <RoundBlockIcon
          data-testid={`confirm-updates-modal_lower-orgs-ban_${item.propertyName}`}
          size="16px"
          color="danger"
        />
      )}
    </Box>
  </Box>
);

export default ConfirmUpdatesPropertyRow;
